import { Component, Input } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { FlexModule } from '@angular/flex-layout';
import { IProblemsDetailed } from '../../../../../../../interfaces/Problems/IProblemsDetailed';

@Component({
  selector: 'app-current-problems-expand',
  standalone: true,
  templateUrl: './current-problems-expand.component.html',
  styleUrls: ['./current-problems-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, FlexModule],
})
export class CurrentProblemsExpandComponent {
  @Input() item: IProblemsDetailed = {};
}
